    <div
      class="m-portlet"
      style="margin: 0;"
      [style.paddingBottom]="previewMode === 'Apple' ? '147%' :
                              previewMode === 'Google' ? '120%' : '50%' "
    >
      <div class="sticky-inner">
      <div class="m-portlet__head" style="height: 6.25vw; max-height: 85px;">
        <div class="m-portlet__head-caption" style="display: flex; height: 100%;">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text coupon-preview-header">
              Coupon preview
            </h3>
          </div>
          <div class="preview-buttons">
            <button
              type="button"
              class="preview-mode-container"
              style="margin-right: 5px;"
              [style.border]="previewMode === 'Apple' ? '2px solid black' : ''"
              (click)="previewMode = 'Apple';"
            >
              <img
                src="../../../assets/app/media/img/icons/apple-icon.png"
                tooltip="Click here to see the Apple Wallet preview"
              />
            </button>
            <button
              type="button"
              class="preview-mode-container"
              [style.border]="previewMode === 'Google' ? '2px solid black' : ''"
              (click)="previewMode = 'Google';"
            >
              <img
                src="../../../assets/app/media/img/icons/google-icon.png"
                tooltip="Click here to see the Google Offer preview"
              />
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="previewMode === 'Apple'" class="m-portlet__body coupon-body" style="height: 75%;">
        <div
          class="coupon-preview"
          [ngStyle]="{ background: form.get('backgroundColor').value }"
        >
          <div class="head">
            <img [src]="form.get('logoLarge').value" [class]="uploadLogoFocus ? 'highlighted logo-apple' : 'logo-apple'" />
            <div [class]="expirationDateFocus ? 'highlighted' : ''" style="margin: 2px; margin-right: 4%;">
              <h3 style="color: white; font-size: 0.75vw;">
                EXPIRATION
              </h3>
              <small
                style="color: white; font-size: 1.2vw;"
                >{{ form.get("expire").value | date }}</small
              >
            </div>
          </div>
          <div class="main">
            <img [class]="uploadStripFocus ? 'highlighted mainBg' : 'mainBg'" [src]="form.get('stripLarge').value" />
          </div>
          <div class="foot">
            <div [class]="offerFocus ? 'highlighted offer' : 'offer'">
              <h3 [ngStyle]="{ color: form.get('labelColor').value }" style="font-size: 0.8vw;">
                OFFER
              </h3>
              <small
                [ngStyle]="{ color: form.get('labelColor').value }"
                style="font-size: 0.75vw;"
              >
                {{ form.get("offer").value }}
              </small>
            </div>
            <div
              *ngIf="form.controls.barcodeType.value !== 'None'"
              class="barcode-image"
              [ngClass]="{
                'expand-barcode-container':
                  form.get('barcodeType').value === 'pdf417'
              }"
              [class]="barcodeFocus ? 'highlighted' : ''"
            >
              <img #barcodeImage [src]="imgUrl" style="width: 100%; height: 100%;" />
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="previewMode === 'Google'" class="m-portlet__body" style="width: 100%; height: 70%;">
        <div
          class="coupon-preview-google"
          [ngStyle]="{ background: form.get('backgroundColor').value }"
        >
          <div class="head">
            <img [src]="form.get('iconLarge').value" [class]="uploadIconFocus ? 'highlighted' : ''" />
          </div>
          <div class="main">
            <div
              [ngStyle]="{ color: form.get('labelColor').value }"
              [class]="providerFocus ? 'highlighted provider' : 'provider'"
            >
              {{ form.get("provider").value }}
            </div>
            <div class="offer" style="margin-top: 0.5vw;">
              <small
                style="font-size: 1.35vw;"
                [ngStyle]="{ color: form.get('labelColor').value }"
                [class]="offerFocus ? 'highlighted offer' : 'offer'"
              >
                {{ form.get("offer").value }}
              </small>
            </div>
          </div>
          <div class="foot">
            <img [class]="uploadStripFocus ? 'highlighted mainBg' : 'mainBg'" [src]="form.get('stripLarge').value" />
          </div>
        </div>
      </div>
        <div
            class="m-portlet__body"
            style="display: flex; justify-content: center;"
        >
            <button
                (click)="close()"
                type="button"
                class="btn btn-danger"
            >
            Close Preview
            </button>
        </div>
      </div>
    </div>
